var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Mentorship = function Mentorship(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M14 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.88 18H17a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v13a1 1 0 0 0 1.664.747L8.88 18ZM5.586 6.586A2 2 0 0 1 7 6h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-1.126a4.002 4.002 0 0 0-7.768.08 1 1 0 0 0-.27.173L5 18.773V8a2 2 0 0 1 .586-1.414Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Mentorship;